import {useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';

import styles from './ScrollToTop.module.scss';

const ScrollToTop: React.FC = () => {
    const [showScrollTop, setShowScrollTop] = useState(false);
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }, [location.pathname]);

    useEffect(() => {
        const handleScroll = () => setShowScrollTop(window.scrollY > 400);
        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => window.scrollTo({top: 0, behavior: 'smooth'});

    return (
        <button
            className={`${styles.scrollToTop} ${showScrollTop ? styles.visible : ''}`}
            onClick={scrollToTop}
            aria-label="Прокрутить наверх"
        >
            <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
            </svg>
        </button>
    );
};

export default ScrollToTop;